import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'question-review-task';

const ELEMENTS = define({
  // A plain `Label` with no role, whose four texts (Todo / In Review /
  // Reviewed / Done) also render on every reviewer card on the same page and as
  // the task list's filter tabs.
  STATUS_TAG: ['status', 'tag'],
  // Per reviewer card, so up to three of these exist at once — the spec adds a
  // single reviewer and scopes by index. Needed because the card tag carries
  // the same four texts as the header tag above it.
  REVIEWER_CARD_STATUS_TAG: ['reviewer-card-status', 'tag'],
  // "Add Reviewer" is the trigger, the dialog's title *and* the dialog's submit
  // button, so role + name resolves two buttons the moment the modal opens.
  // Applied to the trigger; the submit is a `FormButton` and cannot take an id,
  // so it is reached by scoping to the dialog.
  ADD_REVIEWER_BUTTON: ['add-reviewer', 'button'],
  // Asserted hidden after the review is accepted.
  FINISH_TASK_BUTTON: ['finish-task', 'button'],
});

export const QUESTION_REVIEW_TASK_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
